export default __webpack_public_path__ + "static/media/mojaco_greeting_medium.b35f9145.png";